export default "__VITE_ASSET__CSXXjP8Z__"